import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Menu, MenuItem, ButtonGroup, Button, Icon } from '@sm/wds-react';
import { getSiteSupportedLanguages } from '@sm/locale';
import { getLanguageNameFromCode } from '../../../helpers/languageHelpers';

export default class LanguageMenuLI extends Component {
  state = { show: false };

  supportedLanguages = () => {
    const { lang } = this.props;
    return getSiteSupportedLanguages().filter(
      language => language.code !== lang && language.code !== 'en-gb'
    );
  };

  handleChange = () => {
    const { show } = this.state;
    // You can log if the user opened or closed the menu
    this.setState({ show: !show });
  };

  render() {
    const supportedLILanguages = this.supportedLanguages();
    const orderedLILanguages = supportedLILanguages.sort(
      (a, b) => a.displayOrder - b.displayOrder
    );
    const currentLanguageName = getLanguageNameFromCode(this.props.lang);
    const menuTrigger = (
      <div onChange={this.handleChange}>
        <ButtonGroup>
          <Button size="sm" color="secondary">
            {currentLanguageName}
          </Button>
          <Button size="sm" color="secondary">
            <Icon>–</Icon>
          </Button>
        </ButtonGroup>
      </div>
    );
    return (
      <Menu
        dense
        placement="top-left"
        show={this.state.show}
        menuTrigger={menuTrigger}
      >
        {orderedLILanguages.map(langItem => {
          return (
            <MenuItem
              key={langItem.code}
              isNavigable
              navigationTarget={`/user/language?languageid=${langItem.id}&ut_source=footer`}
            >
              {langItem.displayName}
            </MenuItem>
          );
        })}
      </Menu>
    );
  }
}

LanguageMenuLI.propTypes = {
  lang: PropTypes.string,
};

LanguageMenuLI.defaultProps = {
  lang: 'en',
};
